import { render, staticRenderFns } from "./change-log-dialog.vue?vue&type=template&id=1e152294&scoped=true"
import script from "./change-log-dialog.vue?vue&type=script&lang=js"
export * from "./change-log-dialog.vue?vue&type=script&lang=js"
import style0 from "./change-log-dialog.vue?vue&type=style&index=0&id=1e152294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e152294",
  null
  
)

export default component.exports